import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

interface Props {
  title?: string | null;
  text?: string | null;
  footer?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const AlertModal: FC<Props> = ({ isOpen, onClose, text, title, footer }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalCloseButton />
        <ModalBody>{text && <Text whiteSpace="pre-line">{text}</Text>}</ModalBody>
        <ModalFooter>{footer}</ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AlertModal;
